import PeopleFill from "~icons/eva/people-fill"
import PersonDeleteFill from "~icons/eva/person-delete-fill"
import { _t } from "@cruisen/i18n"
import { GuestJoinedTripRoomNotificationData } from "@cruisen/contract"
import styles from "./styles.module.scss"

export const TripGuestsChanged = ({
  data,
  joined,
}: {
  data: GuestJoinedTripRoomNotificationData
  joined: boolean
  iconName: string
}) => (
  <div
    className={styles.container}
    //testID={`navigator-message-guest-${joined ? "joined" : "leaved"}-room`}
  >
    {joined ? <PeopleFill className={styles.icon} /> : <PersonDeleteFill className={styles.icon} />}
    <p>
      {joined
        ? _t("notifications.guestJoinedTripRoom.body", data)
        : _t("notifications.guestLeavedTripRoom.body", data)}
    </p>
  </div>
)
